module.exports = __webpack_public_path__ + "static/media/full.6a9562ca.png";